{
  "title": "Progress",
  "myTitle": "My progress",
  "description": "Attendance, homework and results in one place.",
  "loadFailed": "This progress page could not be loaded.",
  "notAllowed": "You do not have access to this pupil's progress.",
  "noClasses": "Not enrolled in any class yet.",
  "cards": {
    "attendance": "Attendance",
    "attendanceMarked": "Lessons marked: {{marked}}",
    "attendanceNone": "Nothing marked yet",
    "homework": "Homework",
    "homeworkSubmitted": "{{submitted}} of {{assigned}} handed in",
    "homeworkGraded": "{{graded}} graded",
    "onTime": "On time: {{percent}}%",
    "onTimeNone": "No hand-ins yet",
    "tests": "Tests",
    "testsTaken": "{{count}} taken",
    "testsAverage": "Average {{percent}}%",
    "testsNone": "No results yet",
    "projects": "Projects",
    "projectsJoined": "{{count}} joined",
    "projectsGraded": "{{graded}} graded",
    "projectsNone": "Not on a project team yet",
    "points": "Grade points",
    "pointsOf": "{{earned}} of {{possible}}",
    "pointsPercent": "{{percent}}% of graded work",
    "pointsNone": "Nothing graded yet"
  },
  "attendanceBreakdown": "Present {{present}} · Late {{late}} · Excused {{excused}} · Absent {{absent}}",
  "timeline": {
    "title": "Graded work",
    "empty": "Nothing has been graded yet.",
    "score": "{{score}} / {{max}}"
  },
  "kinds": {
    "test": "Test",
    "homework": "Homework",
    "project": "Project",
    "manual": "Column"
  },
  "atRisk": {
    "title": "Needs attention",
    "description": "Pupils in this class who crossed one of the school's thresholds.",
    "empty": "No one in this class is flagged right now.",
    "loadFailed": "The at-risk list could not be loaded.",
    "viewProgress": "Open progress",
    "reasons": {
      "missing_homework": "Overdue homework with nothing handed in: {{value}} (limit {{threshold}})",
      "low_attendance": "Attendance {{value}}% — below {{threshold}}%",
      "low_average": "Average score {{value}}% — below {{threshold}}%"
    },
    "count_one": "{{count}} pupil needs attention",
    "count_other": "{{count}} pupils need attention",
    "dashboardTitle": "Needs attention",
    "dashboardDescription": "Pupils falling behind in the classes you teach.",
    "dashboardEmpty": "Nobody is flagged right now.",
    "dashboardOpen": "Open class"
  }
}
